// extracted by mini-css-extract-plugin
export default {"pagecontent":"styles_pagecontent__dBDyL"};